import { HasOnComplete, HasOnSuccess } from "@insite/client-framework/HandlerCreator";
import { ApiParameter, post } from "@insite/client-framework/Services/ApiService";

export interface ContactUSApiParameter {
    type: string;
    fullName: string;
    companyName: string;
    city: string;
    state: string;
    email: string;
    phoneNumber: string;
    preferredCommunicationMethod: any;
    notes: string;
    products: any;
    additionalRequestedProduct: any;
}
export interface ContactUsResultModel {
    type: string;
    fullName: string;
    companyName: string;
    city: string;
    state: string;
    email: string;
    phoneNumber: string;
    preferredCommunicationMethod: any;
    notes: string;
    products: any;
    additionalRequestedProduct: any;
}
export interface Properties {}

const autocompleteUrl = "api/v1/nonstockproductsrfq";

const contactUS = "api/v1/nonstockproductsrfq";

export function ContactUsForm(
    parameter: ContactUSApiParameter & HasOnSuccess<ContactUsResultModel> & HasOnComplete<ContactUsResultModel>,
) {
    const apiParameter = { ...parameter };
    delete apiParameter.onSuccess;
    delete apiParameter.onComplete;
    return post<ContactUsResultModel>(autocompleteUrl, apiParameter);
}

export function RFQAmail(parameter: ContactUSApiParameter) {
    return post<ContactUSApiParameter, void>(`${contactUS}`, parameter);
}
